/**
* @Author: 858834013@qq.com
* @Name: index
* @Date: 2022-08-24
* @Desc:
*/
<template>
  <div class="itemBody">
    <div class="more" @click="getmore()">
      <i class="el-icon-s-unfold"></i>
      <span>更多</span>
    </div>

    <titleInfo @getHide="getHide" :title="title">

      <tab :list="tablist2" :active.sync="active2"></tab>
    </titleInfo>

    <div class="itemBodyMain">

      <div class="itemBodyMainTop">
          <div class="byzhn">
            本期总耗能：
            <span>{{Number(titledata[0])>10000?(titledata[0]/10000).toFixed(2)+'万':titledata[0]}}</span><span>度</span>
          </div>
          <div class="syzhn">
            上期总耗能：
            <span>{{Number(titledata[1])>10000?(titledata[1]/10000).toFixed(2)+'万':titledata[1]}}</span><span>度</span>
          </div>
      </div>
      <div class="itemBodyMainBottom">
        <echarts :active="active2" @gettitledata="getalldata"></echarts>
      </div>
    </div>
  </div>
</template>

<script>
import titleInfo from "@/components/titleInfo";
import tab from "./components/tab";
import echarts from "@/components/home/item8/echarts";
import Bus from "@/utils/bus.js";
export default {
  name: "index",
  components: {titleInfo, echarts, tab},
  props: {
    title: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    return {
      active2: 0,
      titledata: [0,0],
      tablist2: [{
        name: '当日',
        id: 0,
      }, {
        name: '当月',
        id: 1,
      }]
    }
  },
  watch: {
    active2(){

    }
  },
  mounted() {
  },
  methods: {
    getmore(){
      Bus.$emit('opentc','power')
    },
    getHide() {
      this.$emit('getHide', 0)
    },
    getalldata(val){
    this.titledata=val
    }
  }
}
</script>

<style lang="scss" scoped>

.more{
    width: 50px;
    height: 24px;
    border: 1px solid #4472cb;
    position: absolute;
    top: 8px;
    left: 150px;
  background: url("../../../assets/home/tabbg.png");
  background-size: 100% 100%;
        font-size: 14px;
        font-family: PingFang;
        font-weight: 500;
        color: #46BCFF;
        opacity: 1;
  cursor: pointer;
  z-index: 1000;
}
.itemBody {
  position: relative;
  width: 100%;
  height: 100%;

  .itemBodyMain {
    width: 100%;
    position: relative;
    height: calc(100% - 44px);

    .itemBodyMainTop {
      width: 100%;
      position: relative;
      height: 20%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
      color: #fff;
      .byzhn{
        font-size: 20px;
        color: #049ffb;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
        span {
          font-size: 25px;
          color: #f7b851;
        }
      }
      .syzhn{
        font-size: 20px;
        color: #049ffb;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: row;
        align-content: flex-start;
        span {
          font-size: 25px;
          color: #07FFFD;
        }
      }
    }
    .itemBodyMainBottom {
      width: 100%;
      position: relative;
      height: 80%;
    }
  }
}

.dayTime {
  width: 93px;
  height: 24px;
  background: url("../../../assets/home/dayTimebg.png") no-repeat;
  background-size: 100% 100%;
  margin-right: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: flex-start;

  span {
    font-size: 14px;
    font-family: PingFang;
    font-weight: 500;
    color: #46BCFF;
    margin-left: 15px;
    margin-right: 9px;
  }

  img {
    width: 12px;
    height: 6px;
    margin-right: 15px;
  }
}
</style>
